import { useLayoutEffect, useState } from "react";
import { AppBox } from "../../../commons/components";
import { useAppSelector } from "../../../hooks/app";
import { TournamentTypeEnum } from "../../../commons/enums/tournament-type-enum";
import AppTabs, { TabItem } from "../../../commons/components/Tabs";
import EventsFixtureComponent from "./components/tournamentEvents/EventsFixtureComponent";
import EventsBracketComponent from "./components/tournamentEvents/EventsBracketComponent";

export default function TournamentManageEvents() {
  const { fetchedCompetition } = useAppSelector((state) => state.fetchedCompetition);
  const [eventsType, setEventsType] = useState<string>();
  const GROUPS = "groups";
  const KNOCKOUTS = "knockouts";

  const tabItems = [
    {
      label: "Groups",
      value: GROUPS,
    },
    {
      label: "Knockouts",
      value: KNOCKOUTS,
    },
  ];

  useLayoutEffect(() => {
    if (fetchedCompetition.type === TournamentTypeEnum.Hybrid) {
      setEventsType(GROUPS);
    }
  }, [fetchedCompetition]);

  const handleTabChange = (args: TabItem) => {
    setEventsType(args.value);
  };

  return (
    <AppBox mb="sm" gap="sm" flexDirection="column">
      {fetchedCompetition.type === TournamentTypeEnum.Hybrid && (
        <AppBox>
          <AppTabs
            as="button"
            onClick={handleTabChange}
            tabItems={tabItems}
            variant="filled"
            shadow="xs"
            activeValue={eventsType}
            isFilterTabs
          />
        </AppBox>
      )}
      {(eventsType === GROUPS || fetchedCompetition.type === TournamentTypeEnum.League) && <EventsFixtureComponent />}
      {(eventsType === KNOCKOUTS || fetchedCompetition.type === TournamentTypeEnum.Knockout) && (
        <EventsBracketComponent />
      )}
    </AppBox>
  );
}
